<template>
  <div class="flex gap-3 mb-1">
    <span class="font-bold">{{ t('store.opening_hours') }}: </span>
    <div
      v-if="todaysOpeningHoursOnly && hasOpeningHoursForToday"
      class="grid grid-cols-[min-content_fit-content(100%)] gap-x-4"
    >
      <span>{{ t(days[today === 0 ? 6 : today - 1].toLowerCase()) }} </span>
      <span>{{ todaysOpeningHours }}</span>
      <span v-if="moreOpeningHoursOnStorePage" class="col-span-2 mt-1">
        {{ t('store.see_all_opening_hours_on_the_store_page') }}
      </span>
    </div>
    <div v-else>
      <div v-for="(value, key) in openingHours" :key="key" class="grid grid-cols-2">
        <span>{{ t(`${key.toLowerCase()}`) }} </span>
        <span>{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

type Props = {
  openingHours: Record<string, string>;
  todaysOpeningHoursOnly: boolean;
  moreOpeningHoursOnStorePage: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  openingHours: () => ({}),
  todaysOpeningHoursOnly: true,
  moreOpeningHoursOnStorePage: false,
});

const { t } = useI18n();

const today = ref(new Date().getDay());

const todaysOpeningHours = computed(() => {
  return props.openingHours[days[today.value === 0 ? 6 : today.value - 1]];
});

const hasOpeningHoursForToday = computed(() => {
  return !!todaysOpeningHours.value;
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'StoreOpeningHours',
});
</script>
